export default __webpack_public_path__ + "static/media/hackMOL1.7782788a.jpg";